"use client";
import deskTopImage from "@root/src/assets/images/collection/banner_collection_desktop_bottom.png";
import tabLetImage from "@root/src/assets/images/collection/banner_collection_tablet_bottom.png";
import mobileImage from "@root/src/assets/images/collection/banner_collection_mobile_bottom.png";
import ResponsiveBanner from "@components/themes/lytra/common/ResponsiveBanner";

interface HeroBannerBottomCategoryProps {
  collection: {
    name: string;
    description?: string;
    image?: string[] | string;
  };
}

export default function HeroBannerBottomCategory({ collection }: HeroBannerBottomCategoryProps) {
  return (
    <ResponsiveBanner
      alt={collection.name}
      desktopSrc={deskTopImage}
      tabletSrc={tabLetImage}
      mobileSrc={mobileImage}
      sizes="100vw"
      backgroundColor="#f5eee0"
    />
  );
}
